import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import subscriptionService from '../../services/subscriptionService';
import Navbar from '../../components/Navbar';
import InternalNavbar from '../../components/InternalNavbar';
import Footer from '../../components/footer';
import { Helmet } from 'react-helmet-async';
import Logo from '../../images/logo.svg';
import './style.css';

const TrialExpiredPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const SUBSCRIPTION_PRICE = 49;
  const OLD_PRICE = 59;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Redirect non-authenticated users to login
  useEffect(() => {
    if (!user) {
      navigate('/login', { state: { from: '/trial-expired' } });
    }
  }, [user, navigate]);

  const handleSubscribe = async () => {
    try {
      setLoading(true);
      setError(null);

      const checkoutData = {
        amount: SUBSCRIPTION_PRICE,
        currency: 'EUR',
        success_url: `${window.location.origin}/payment-success`,
        cancel_url: `${window.location.origin}/trial-expired`
      };

      const response = await subscriptionService.createCheckoutSession(checkoutData);

      // Redirect to Stripe checkout
      window.location.href = response.checkout_url;
    } catch (err) {
      console.error('Checkout error:', err);
      setError(err.response?.data?.error?.message || 'Failed to initiate payment. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="trial-expired-page-wrapper">
      <Helmet>
        <title>{t('trialExpired.pageTitle')}</title>
        <meta name="description" content={t('trialExpired.metaDescription')} />
      </Helmet>
      <Navbar Logo={Logo} hclass={'wpo-header-style-1'} />
      <div className="trial-expired-page">
        <div className="trial-expired-arabic-bg" />

        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="trial-expired-text-content">
                <div className="expired-icon">⏱️</div>
                <h1>{t('trialExpired.heroTitle')}</h1>
                <p className="trial-expired-intro">
                  {t('trialExpired.heroSubtitle')}
                </p>

                <p className="trial-expired-message">
                  {t('trialExpired.startLearning')}
                </p>

                <div className="trial-expired-features">
                  <div className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span>{t('trialExpired.feature1')}</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span>{t('trialExpired.feature2')}</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span>{t('trialExpired.feature3')}</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span>{t('trialExpired.feature4')}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="trial-expired-action-content">
                <div className="trial-expired-pricing">
                  <p className="pricing-text">
                    <strong>{t('trialExpired.specialOffer')}</strong> {t('trialExpired.offerDescription')}
                  </p>
                  <div className="price-display">
                    <span className="old-price-label">{t('trialExpired.oldPriceLabel')} <span className="old-price-value">${OLD_PRICE}</span></span>
                    <span className="new-price-label">{t('trialExpired.newPriceLabel')} <span className="new-price-value">${SUBSCRIPTION_PRICE}</span></span>
                  </div>
                </div>

                {error && (
                  <div className="error-message">
                    {error}
                  </div>
                )}

                <button
                  className="proceed-trial-expired-btn"
                  onClick={handleSubscribe}
                  disabled={loading}
                >
                  {loading ? t('trialExpired.loading') : t('trialExpired.ctaButton')}
                </button>

                <button
                  onClick={() => navigate('/dashboard')}
                  className="btn-secondary-trial"
                >
                  {t('trialExpired.backToDashboard')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TrialExpiredPage;
